<template>
    <div>
        <div v-if="editing"
            class="border border-gray-300 bg-gray-warm-50 rounded-md px-6 py-5"
        >
            <h2 class="text-gray-400 text-lg font-semibold pb-3">
                Envelope Title
            </h2>

            <input-text
                v-model="title_proxy"
                name="envelope-title"
                input_class="text-lg font-semibold w-full"
                :autofocus="true"
            />
        </div>

        <div v-else>
            <h2 class="text-xl font-semibold">
                {{ value }}
            </h2>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: { default: () => [] },
        editing: { default: false },
    },

    data() {
        return {
            title_proxy: [],
        }
    },

    created() {
        this.title_proxy = this.value;
    },

    watch: {
        title_proxy: {
            deep: true,
            handler(value) {
                this.$emit('input', value);
            },
        },
    },
}
</script>
